var map = {
	"./100/SaoPaulo/kmeans/SaoPaulo_kmeans_202_100.csv": 35,
	"./150/SaoPaulo/kmeans/SaoPaulo_kmeans_202_150.csv": 36,
	"./200/SaoPaulo/kmeans/SaoPaulo_kmeans_202_200.csv": 37,
	"./250/SaoPaulo/kmeans/SaoPaulo_kmeans_202_250.csv": 38,
	"./300/SaoPaulo/kmeans/SaoPaulo_kmeans_202_300.csv": 39,
	"./350/SaoPaulo/kmeans/SaoPaulo_kmeans_202_350.csv": 40,
	"./400/SaoPaulo/kmeans/SaoPaulo_kmeans_202_400.csv": 41,
	"./450/SaoPaulo/kmeans/SaoPaulo_kmeans_202_450.csv": 42,
	"./50/SaoPaulo/kmeans/SaoPaulo_kmeans_202_50.csv": 43,
	"./500/SaoPaulo/kmeans/SaoPaulo_kmeans_202_500.csv": 44,
	"./saopaulo-categories.csv": 15
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;